// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"4579795a01331cf2b4bb","655":"46bff8cc67e1754a3cd0"}[chunkId] + ".js";
};